<!-- git/truth-first-look/src/components/dashboard/PostCard.tsx (motion.article → article) -->
<article class="px-4 py-3.5 border-b border-border bg-card hover:bg-secondary/30 transition-colors duration-150 cursor-pointer">
  <div *ngIf="post.isRepost && post.repostedBy" class="flex items-center gap-2 ml-12 mb-1.5 text-[13px] text-muted-foreground">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
      <path d="M17 1l4 4-4 4" />
      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
      <path d="M7 23l-4-4 4-4" />
      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
    </svg>
    <span class="font-medium">{{ post.repostedBy }} reposted</span>
  </div>

  <div class="flex gap-3">
    <div class="flex-shrink-0">
      <div class="w-10 h-10 rounded-full overflow-hidden bg-muted ring-1 ring-border">
        <img [src]="post.avatarUrl" alt="" class="w-full h-full object-cover" loading="lazy" />
      </div>
    </div>

    <div class="flex-1 min-w-0">
      <div class="flex items-start justify-between gap-2">
        <div class="flex items-center gap-1.5 min-w-0 flex-wrap">
          <span class="font-semibold text-[15px] text-foreground truncate">{{ post.displayName }}</span>
          <span class="text-[14px] text-muted-foreground truncate">&#64;{{ post.handle }}</span>
          <span class="text-muted-foreground/50 text-[13px]">·</span>
          <span class="text-[13px] text-muted-foreground whitespace-nowrap">{{ post.date }}</span>
        </div>

        <div class="relative flex-shrink-0">
          <button type="button" (click)="toggleMenu($event)" class="p-1.5 rounded-full text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors" aria-label="More">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <circle cx="12" cy="5" r="1.5" />
              <circle cx="12" cy="12" r="1.5" />
              <circle cx="12" cy="19" r="1.5" />
            </svg>
          </button>
          <ng-container *ngIf="showMenu">
            <div class="fixed inset-0 z-40" (click)="closeMenu()"></div>
            <div class="absolute right-0 top-full mt-1 z-50 w-52 bg-card rounded-xl border border-border shadow-xl overflow-hidden animate-fade-in">
              <ng-container *ngIf="post.isOwner">
                <button type="button" class="w-full flex items-center gap-3 px-4 py-2.5 text-[14px] transition-colors text-foreground hover:bg-secondary">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                  </svg>
                  Edit Post
                </button>
                <button type="button" class="w-full flex items-center gap-3 px-4 py-2.5 text-[14px] transition-colors text-destructive hover:bg-destructive/10">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6" />
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                  </svg>
                  Delete Post
                </button>
                <button type="button" class="w-full flex items-center gap-3 px-4 py-2.5 text-[14px] transition-colors text-foreground hover:bg-secondary">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                  Pin Post
                </button>
              </ng-container>
              <ng-container *ngIf="!post.isOwner">
                <button type="button" class="w-full flex items-center gap-3 px-4 py-2.5 text-[14px] transition-colors text-foreground hover:bg-secondary">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
                    <line x1="23" y1="9" x2="17" y2="15" />
                    <line x1="17" y1="9" x2="23" y2="15" />
                  </svg>
                  Mute &#64;{{ post.handle }}
                </button>
                <button type="button" class="w-full flex items-center gap-3 px-4 py-2.5 text-[14px] transition-colors text-destructive hover:bg-destructive/10">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                  </svg>
                  Block &#64;{{ post.handle }}
                </button>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>

      <p class="text-[15px] leading-[1.5] text-foreground mt-0.5 whitespace-pre-wrap break-words">{{ post.text }}</p>

      <app-lovable-media-grid *ngIf="post.media?.length" [media]="post.media!"></app-lovable-media-grid>

      <div *ngIf="post.quotedPost" class="mt-3 border border-border rounded-2xl overflow-hidden hover:bg-secondary/30 transition-colors">
        <div class="px-3.5 py-3">
          <div class="flex items-center gap-1.5 mb-1">
            <div class="w-5 h-5 rounded-full overflow-hidden bg-muted">
              <img [src]="post.quotedPost.avatarUrl" alt="" class="w-full h-full object-cover" />
            </div>
            <span class="text-[13px] font-semibold text-foreground">{{ post.quotedPost.displayName }}</span>
            <span class="text-[13px] text-muted-foreground">&#64;{{ post.quotedPost.handle }}</span>
            <span class="text-muted-foreground/50 text-xs">·</span>
            <span class="text-[12px] text-muted-foreground">{{ post.quotedPost.date }}</span>
          </div>
          <p class="text-[14px] leading-[1.45] text-foreground">{{ post.quotedPost.text }}</p>
          <app-lovable-media-grid *ngIf="post.quotedPost.media?.length" [media]="post.quotedPost.media!"></app-lovable-media-grid>
        </div>
      </div>

      <app-lovable-post-action-bar
        [commentCount]="post.commentCount ?? 0"
        [repostCount]="post.repostCount ?? 0"
        [likeCount]="post.likeCount ?? 0"
        [scoreCount]="post.scoreCount ?? 0"
        [liked]="post.liked ?? false"
        [reposted]="post.reposted ?? false"
        [scored]="post.scored ?? false">
      </app-lovable-post-action-bar>
    </div>
  </div>
</article>
